import { ColumnChooserModel } from "../../common/ColumnChooserModel"
import { ColumnFilterModel } from "../../common/ColumnFilterModel"

export interface GetJnjPaymentListRequest {
    searchTerm: string
    skip: number
    take: number
    sortColumn?: string
    sortDirection?: string
    columnChooser: ColumnChooserModel[] | undefined
    currentPage: number
    /** Kolon başlıklarının altındaki filtreler. */
    columnFilters: ColumnFilterModel[]
    /** Excel "Seçilenler" için işaretli kayıtlar. */
    ids?: string[]
    /** true: yalnız vade tarihi boş kayıtlar. */
    onlyEmptyDueDate?: boolean
    /** true: yalnız ödeme tarihi boş kayıtlar. */
    onlyEmptyPaymentDate?: boolean
}

export const initialGetJnjPaymentListRequest: GetJnjPaymentListRequest = {
    searchTerm: '',
    skip: 0,
    take: 50,
    currentPage: 1,
    // Varsayılan: Fatura No küçükten büyüğe (Burak, 07.10.2026).
    sortColumn: 'invoiceNumber',
    sortDirection: 'asc',
    columnChooser: undefined,
    columnFilters: []
}
